// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProposalDecision } from './proposal-decision';
import {
    ProposalDecisionFromJSON,
    ProposalDecisionFromJSONTyped,
    ProposalDecisionToJSON,
    ProposalDecisionToJSONTyped,
} from './proposal-decision';

/**
 * 
 * @export
 * @interface UpdateProposalRequest
 */
export interface UpdateProposalRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateProposalRequest
     */
    applied_version?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateProposalRequest
     */
    review_comment?: string;
    /**
     * 
     * @type {ProposalDecision}
     * @memberof UpdateProposalRequest
     */
    status: ProposalDecision;
}



/**
 * Check if a given object implements the UpdateProposalRequest interface.
 */
export function instanceOfUpdateProposalRequest(value: object): value is UpdateProposalRequest {
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function UpdateProposalRequestFromJSON(json: any): UpdateProposalRequest {
    return UpdateProposalRequestFromJSONTyped(json, false);
}

export function UpdateProposalRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateProposalRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'applied_version': json['applied_version'] == null ? undefined : json['applied_version'],
        'review_comment': json['review_comment'] == null ? undefined : json['review_comment'],
        'status': ProposalDecisionFromJSON(json['status']),
    };
}

export function UpdateProposalRequestToJSON(json: any): UpdateProposalRequest {
    return UpdateProposalRequestToJSONTyped(json, false);
}

export function UpdateProposalRequestToJSONTyped(value?: UpdateProposalRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'applied_version': value['applied_version'],
        'review_comment': value['review_comment'],
        'status': ProposalDecisionToJSON(value['status']),
    };
}
